import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} TravXplo. All rights reserved.</p>
      <div className="footer-links">
        <Link to="/privacy-policy">Privacy Policy</Link>
        <span>|</span>
        <Link to="/terms-of-service">Terms of Service</Link>
        <span>|</span>
        <Link to="/refund-policy">Refund Policy</Link>
        <span>|</span>
        <Link to="/disclaimer">Disclaimer</Link>
      </div>
    </footer>
  );
}
